import { Button, Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { ErrorStateContentBox } from 'components/ErrorStates/ErrorStateContentBox/ErrorStateContentBox';
import { useNavigate } from 'react-router';

export const NoPermissionContent = () => {
  const navigate = useNavigate();
  return (
    <ErrorStateContentBox
      headingText={"You don't have access to this page"}
      subText={
        <>
          <div>The page you are trying to access has been restricted.</div>
          <div>Please contact your administrator to request access.</div>
        </>
      }
      actions={[
        <Button key="go-home" onClick={() => navigate('/')} variant="filled">
          Head home
        </Button>,
      ]}
    />
  );
};

export const NoPermissionErrorState = () => {
  return (
    <Flexbox flexDirection={'column'} style={{ height: '100vh' }}>
      <NoPermissionContent />
    </Flexbox>
  );
};
